import { Box, Stack, ToggleButton } from "@mui/material"
import { BoundToggleButtonGroup } from "lib/@components/binding/bound-components.js"
import Iconify from "minimals-template/components/Iconify.js"

export function MappingAssetTypeSetting() {
    return (
        <BoundToggleButtonGroup
            size="small"
            fullWidth
            field="originalTypes"
            defaultValue={false}
            data-cy="mapping-original-types"
        >
            <ToggleButton value={false} data-cy="mapping-original-types-computed">
                <Stack direction="row" spacing={1} alignItems="center">
                    <Iconify icon="mdi:chart-donut" />
                    <Box>Computed Types</Box>
                </Stack>
            </ToggleButton>
            <ToggleButton value={true} data-cy="mapping-original-types-unrefined">
                <Stack direction="row" spacing={1} alignItems="center">
                    <Iconify icon="mdi:format-list-bulleted" />
                    <Box>Unrefined Types</Box>
                </Stack>
            </ToggleButton>
        </BoundToggleButtonGroup>
    )
}
